var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium/ArrowUp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0672 9.19219C16.0091 9.2503 15.9402 9.2964 15.8643 9.32785C15.7885 9.35931 15.7071 9.37549 15.625 9.37549C15.5429 9.37549 15.4615 9.35931 15.3857 9.32785C15.3098 9.2964 15.2409 9.2503 15.1828 9.19219L10.625 4.6336V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V4.6336L4.81719 9.19219C4.69991 9.30947 4.54085 9.37535 4.375 9.37535C4.20915 9.37535 4.05009 9.30947 3.93281 9.19219C3.81554 9.07492 3.74965 8.91586 3.74965 8.75C3.74965 8.58415 3.81554 8.42509 3.93281 8.30782L9.55781 2.68282C9.61586 2.62471 9.68479 2.57861 9.76066 2.54715C9.83654 2.5157 9.91787 2.49951 10 2.49951C10.0821 2.49951 10.1635 2.5157 10.2393 2.54715C10.3152 2.57861 10.3841 2.62471 10.4422 2.68282L16.0672 8.30782C16.1253 8.36586 16.1714 8.43479 16.2029 8.51067C16.2343 8.58654 16.2505 8.66787 16.2505 8.75C16.2505 8.83214 16.2343 8.91347 16.2029 8.98934C16.1714 9.06522 16.1253 9.13415 16.0672 9.19219Z",
    fill: "url(#paint0_linear_2827_13514)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2827_13514",
    x1: 16.2505,
    y1: 2.49951,
    x2: 3.74965,
    y2: 2.49951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465749,
    stopColor: "#8937A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455AC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.28b4319bc25615ded37fc44f385502f5.svg";
export { ForwardRef as ReactComponent };